module.exports = __webpack_public_path__ + "img/banner1.620a4e51.png";